export default __webpack_public_path__ + "static/media/xmlIcon.dededb26.svg";